export const absenceTranslations = {
  lv: {
    title: 'Prombūtne',
    description:
      'Prombūtni reģistrē prakses vadītājs izglītības iestādē — piemēram, slimības vai attaisnota kavējuma gadījumā. Aizverot prombūtni, viņš norāda attaisnoto stundu skaitu, un tās pieskaitās izpildītajām.',
    open: 'Nav aizvērta',
    empty: 'Prombūtnes ieraksti nav atrasti.',
    loadError: 'Neizdevās ielādēt prombūtnes ierakstus',
    loadErrorHelp: 'Pārbaudiet savienojumu un mēģiniet vēlreiz.',
    statusError: 'Neizdevās ielādēt prombūtnes kopsavilkumu',
    statusErrorHelp: 'Kopsavilkuma dati pašlaik nav pieejami.',
    columns: {
      start: 'No',
      end: 'Līdz',
      days: 'Dienas',
      reason: 'Iemesls',
      info: 'Pamatojums',
      hours: 'Ieskaitītas h',
    },
    types: {
      NotSet: 'Nav norādīts',
      Sick: 'Slimība',
      Other: 'Cits iemesls',
    },
    summary: {
      total: 'Kopā prombūtnē',
      totalDescription: 'Darbdienas, ko sedz prombūtne',
      creditedHours: 'Ieskaitītas stundas',
      creditedHoursDescription: 'Pieskaitīts izpildītajām',
      current: 'Šobrīd prombūtnē',
      absent: 'Šobrīd prombūtnē',
      absentFrom: 'No {{date}}',
      notAbsent: '—',
      notAbsentDescription: 'Šobrīd prombūtnē neesi',
    },
  },
  en: {
    title: 'Absence',
    description:
      'Absences are registered by the educational institution’s internship supervisor—for example, for illness or an excused absence. When closing an absence, they enter the credited hours, which are added to completed work.',
    open: 'Still open',
    empty: 'No absence records found.',
    loadError: 'Could not load absence records',
    loadErrorHelp: 'Check your connection and try again.',
    statusError: 'Could not load the absence summary',
    statusErrorHelp: 'Summary data is currently unavailable.',
    columns: {
      start: 'From',
      end: 'To',
      days: 'Days',
      reason: 'Reason',
      info: 'Justification',
      hours: 'Credited h',
    },
    types: {
      NotSet: 'Not specified',
      Sick: 'Illness',
      Other: 'Other reason',
    },
    summary: {
      total: 'Total absence',
      totalDescription: 'Working days covered by absence',
      creditedHours: 'Credited hours',
      creditedHoursDescription: 'Added to completed work',
      current: 'Absent now',
      absent: 'Absent now',
      absentFrom: 'Since {{date}}',
      notAbsent: '—',
      notAbsentDescription: 'You are not absent now',
    },
  },
} as const
